import http from "./http";
var baseUrl = "/common-web";

/**
 * 发文管理
 * */
// 查询发文列表
const getSendListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/system/file/internal/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 查询查阅列表
const getChecklistService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/system/file/internal/checklist", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 新建公文
const addSendFileService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+"/system/file/internal", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 修改公文
const modifySendFileService = (params) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+"/system/file/internal", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 删除公文
const deleteSendFileService = (params) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl+"/system/file/internal", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 公文详情
const getSendDetailService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/system/file/internal/detail", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 内部查阅
const setCheckInternalService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+"/system/file/internal/check", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 修改状态
const setInternalStatusService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+"/system/file/internal/status", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 新建综合办发文
const addZonghebanFileService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+"/system/file/internal/zongheban", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 综合办修改
const modifyZonghebanFileService = (params) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+"/system/file/internal/zongheban", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 删除公文
const deleteZonghebanFileService = (params) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl+"/system/file/internal/zongheban", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}


// 收文修改
const modifyProcessingFileService = (params) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+"/system/file/internal/receive", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 外部文件管理
 * */
// 查询列表
const getExternalListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/system/file/external/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 新建收文
const addReceiveFileService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+"/system/file/external", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 删除公文
const deleteReceiveFileService = (params) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl+"/system/file/external", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 收文详情
const getReceiveDetailService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/system/file/external/detail", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 修改公文
const modifyReceiveFileService = (params) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+"/system/file/external", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 设置查阅
const setCheckExternalService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+"/system/file/external/check", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 发文分类管理
 * */
// 查询发文分类列表
const getTypeListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/system/file/type/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 查询文件类别详情
const getTypeDetailService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/system/file/type/detail", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 新建公文分类
const setAddFileTypeService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+"/system/file/type", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 更新公文分类
const setUpdateFileTypeService = (params) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+"/system/file/type", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 删除公文分类
const deleteFileTypeService = (params) => {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl+"/system/file/type", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

//查询内部文件查阅列表
const getCheckListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/system/file/internal/process/check/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//查询内部文件查阅列表
const getProcessCommentListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/system/file/internal/process/comment/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

const processCheckerService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+"/system/file/internal/process/checker", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

const processCreatorService = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+"/system/file/internal/process/creator", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
const getInternalCheckService = (params) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl+"/system/file/internal/check", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

export {
    getSendListService,
    getChecklistService,
    addSendFileService,
    modifySendFileService,
    deleteSendFileService,
    getSendDetailService,
    setCheckInternalService,
    setInternalStatusService,

    addZonghebanFileService,
    modifyZonghebanFileService,
    deleteZonghebanFileService,

    modifyProcessingFileService,

    getExternalListService,
    addReceiveFileService,
    deleteReceiveFileService,
    getReceiveDetailService,
    modifyReceiveFileService,
    setCheckExternalService,


    getTypeListService,
    getTypeDetailService,
    setAddFileTypeService,
    setUpdateFileTypeService,
    deleteFileTypeService,

    getCheckListService,
    getProcessCommentListService,
    processCheckerService,
    processCreatorService,
    getInternalCheckService,
}
